import { Injectable } from '@angular/core';
import * as ExcelJS from 'exceljs';
import { MatTableDataSource } from '@angular/material/table';
import { CommonFunctions } from './CommonComponent/function/commonfunctions';

@Injectable({
  providedIn: 'root'
})
export class ExcelExportService {

  constructor(private commonFunctions: CommonFunctions) { }

  exportMatTableToExcel(dataSource: MatTableDataSource<any>, columns: any[], filename: string) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet 1');

    const themeArgb = this.commonFunctions.getThemeColorArgb();

    // Set columns headers in the Excel sheet
    worksheet.columns = columns.map(column => ({ header: column.header, key: column.field, width: Math.max(15, column.header.length + 5) }));

    // Populate data rows in the Excel sheet
    dataSource.data.forEach(item => {
      worksheet.addRow(item);
    });

    // Style Header Row
    const headerRow = worksheet.getRow(1);
    headerRow.height = 24;
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: themeArgb }
      };
      cell.font = {
        name: 'Calibri',
        size: 11,
        bold: true,
        color: { argb: 'FFFFFFFF' }
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center'
      };
      cell.border = {
        top: { style: 'thin', color: { argb: 'FFFFFFFF' } },
        left: { style: 'thin', color: { argb: 'FFFFFFFF' } },
        bottom: { style: 'thin', color: { argb: 'FFFFFFFF' } },
        right: { style: 'thin', color: { argb: 'FFFFFFFF' } }
      };
    });

    workbook.xlsx.writeBuffer().then(buffer => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = `${filename}.xlsx`;
      a.click();

      window.URL.revokeObjectURL(url);
    });
  }
}

